/**
 * How many units of a service one cart line may hold — the client mirror of
 * the server's `maxPurchasableQuantity` (marketplace/services/order.service.ts):
 *   - allowQuantity false → 1 (single-entitlement service);
 *   - restrictionQuantity > 0 → that cap;
 *   - otherwise no cap (Infinity).
 * Plans are always 1.
 */
export function maxQuantityFor(item) {
  if (!item || item.isPlan) return 1;
  if (!item.allowQuantity) return 1;
  return item.restrictionQuantity > 0 ? item.restrictionQuantity : Infinity;
}

/** Clamp a requested quantity to [1, maxQuantityFor(item)]. */
export function clampQuantity(item, quantity) {
  const q = Math.floor(Number(quantity) || 1);
  return Math.min(Math.max(1, q), maxQuantityFor(item));
}
